import React, { useEffect, useReducer, useRef } from "react";
import PinPop from "./PinPop";
import { compose, withProps, withStateHandlers, lifecycle } from "recompose";
import { MAP } from "react-google-maps/lib/constants";
import { CloseOutlined } from "@ant-design/icons";
import DirectionPop from "./DirectionPop";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Circle,
  DirectionsRenderer,
  Polygon,
  InfoWindow,
  Polyline,
  DrawingManager,
} from "@react-google-maps/api";
import { resolveObjectURL } from "buffer";
import { pushNotification } from "utils/notifications";
import { Button, Col, Row, Image } from "antd";
import VideoPlayerModal from "components/Modals/VideoPlayerModal";

const {
  MarkerClusterer,
} = require("react-google-maps/lib/components/addons/MarkerClusterer");

const MeasureTool = require("measuretool-googlemaps-v3");

const getPaths = (polygon: any) => {
  var polygonBounds = polygon.getPath().getArray();
  var bounds = [];
  for (var i = 0; i < polygonBounds.length; i++) {
    var point = {
      lat: polygonBounds[i].lat(),
      lng: polygonBounds[i].lng(),
    };
    bounds.push(point);
  }
  bounds.push(bounds[0]);
  return bounds;
};

/*global google*/

const libraries: any = ["places", "geometry", "drawing"];
const mapIds = ["bc10cdbc8ba6566d"];
const defaultLocation = { lat: 40.756795, lng: -73.954298 };
const googleMapsApiKey = "AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY";
let timeout: NodeJS.Timeout;

const Map = (props) => {
  const [mapRef, setMapRef] = React.useState(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const [activeMarker, setActiveMarker] = React.useState(null);
  const [directions, showDirection] = React.useState(null);
  const [selectDirectionPin, setSelectDirectionPin] = React.useState(null);
  const [drawingMode, setDrawingMode] = React.useState(null);
  const [polyline, setPolyline] = React.useState(false);
  const [insideBox, setInsideBox] = React.useState([]);
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const [videoModalOpen, setVideoModalOpen] = React.useState();

  // const [gpsReportTrack, setGpsReportTrack] = React.useState([]);

  const gpsReportTrack = useRef<any>({ points: [] });

  const {
    active,
    setActive,
    onClick,
    showPanel,
    getPlaces,
    clearPlaces,
    gpsMarkers,
    lockTracking,
    latestUpdateImei,
    settings,
    activePop,
    markers,
    polygons,
    circles,
    mode,
    currentLocation,
    mapType,
    toggleLock,
  } = props;

  const onToggleOpen = (marker) => {
    setIsOpen(!isOpen);
    setActiveMarker(marker);
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey,
    libraries,
    mapIds,
  });

  const { edit_place, gps } = useSelector(
    (state: RootState) => state.dashboard
  );

  const handleDirections = (destination: DestinationObj) => {
    const DirectionsService = new google.maps.DirectionsService();
    DirectionsService.route(
      {
        origin: selectDirectionPin,
        destination: new google.maps.LatLng(destination.lat, destination.lng),
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          showDirection(result);
          showPanel(true);
          setActive(true);
          setSelectDirectionPin(null);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  };

  const existInsideBox = (p, bb) => {
    if (bb.ix <= p.x && p.x <= bb.ax && bb.iy <= p.y && p.y <= bb.ay) {
      return true;
    } else return false;
  };

  const onBoundsChanged = () => {
    if (mapRef) {
      let zoom = mapRef.getZoom();
      let bounds = mapRef.getBounds();
      if (bounds) {
        let ne = bounds.getNorthEast();
        let sw = bounds.getSouthWest();
        const box = {
          center: mapRef.getCenter(),
          bounds: {
            minLat: sw.lat(),
            maxLat: ne.lat(),
            minLon: sw.lng(),
            maxLon: ne.lng(),
          },
        };

        let tempMarkers = { ...gpsMarkers };
        let insideBox = [];
        Object.keys(tempMarkers).map((key) => {
          tempMarkers?.[key]?.markers?.map((marker) => {
            const existInside = existInsideBox(
              { x: marker.lat, y: marker.lng },
              {
                ix: box.bounds.minLat,
                iy: box.bounds.minLon,
                ax: box.bounds.maxLat,
                ay: box.bounds.maxLon,
              }
            );
            if (existInside) {
              insideBox.push(marker.gpsTimestamp);
            }
          });
        });
        setPolyline(insideBox.length > 300);
        setInsideBox(insideBox);
        getPlaces(box);
      }
    }
  };

  const fitBounds = (gpsMarkersOnly = false) => {
    try {
      if (google) {
        const bounds = new google.maps.LatLngBounds();
        Object.keys(gpsMarkers).forEach((key) => {
          if (
            !lockTracking.checked ||
            (lockTracking.checked &&
              lockTracking.lock === latestUpdateImei.imei)
          ) {
            if (latestUpdateImei.mode || settings.breadcrumbs.length === 0) {
              let lastMarker = gpsMarkers[key].markers[0];
              if (activePop === "filters" && lastMarker) {
                bounds.extend({ lat: lastMarker.lat, lng: lastMarker.lng });
              } else if (mapRef && lastMarker) {
                mapRef.panTo(
                  new google.maps.LatLng({
                    lat: lastMarker.lat,
                    lng: lastMarker.lng,
                  })
                );
              }
            } else {
              gpsMarkers[key].markers.forEach((marker: any) => {
                bounds.extend({ lat: marker.lat, lng: marker.lng });
              });
            }
          }
        });

        if (!gpsMarkersOnly) {
          if (markers.length > 0 && markers[0].fitBounds) {
            markers.forEach((marker: any) => {
              bounds.extend({ lat: marker.lat, lng: marker.lng });
            });
          }

          polygons.forEach((polygon: any) => {
            polygon.paths.forEach((path: any) => {
              bounds.extend(path);
            });
          });
          circles.forEach((circle: any) => {
            bounds.union(
              new google.maps.Circle({
                center: { lat: circle.lat, lng: circle.lng },
                radius: circle.radius,
              }).getBounds()
            );
          });
        }
        if (bounds.isEmpty()) return;
        if (mapRef) {
          if (
            !gpsMarkersOnly &&
            markers.length === 1 &&
            polygons.length === 0 &&
            circles.length === 0
          ) {
            mapRef.panTo(
              new google.maps.LatLng({
                lat: markers[0].lat,
                lng: markers[0].lng,
              })
            );
          } else {
            mapRef.fitBounds(bounds);
          }
        }
      }
    } catch (e) {
      console.log("google failed");
    }
  };

  useEffect(() => {
    onBoundsChanged();
  }, [mapType]);

  useEffect(() => {
    if (currentLocation && mapRef) {
      mapRef.setZoom(16);
    }
  }, [currentLocation]);

  useEffect(() => {
    if (edit_place) {
      if (edit_place.type === "marker") {
        const marker = markers.filter((marker) => {
          return marker.id === edit_place.id;
        });
        if (marker && marker.length === 1) {
          onToggleOpen({
            type: "marker",
            ...marker[0],
            mode: "edit",
          });
        }
      } else if (edit_place.type === "polygon") {
        const polygon = polygons.filter((polygon) => {
          return polygon.id === edit_place.id;
        });
        if (polygon && polygon.length === 1) {
          onToggleOpen({
            type: "polygon",
            ...polygon[0],
            mode: "edit",
          });
        }
      } else if (edit_place.type === "circle") {
        const circle = circles.filter((circle) => {
          return circle.id === edit_place.id;
        });
        if (circle && circle.length === 1) {
          onToggleOpen({
            type: "circle",
            ...circle[0],
            mode: "edit",
          });
        }
      }
    }
  }, [edit_place]);

  useEffect(() => {
    fitBounds();
  }, [markers, polygons, circles]);

  useEffect(() => {
    // if(props.settings.track === 'auto' && (!props.lockTracking.checked || props.localTracking.lock === props.latestUpdateImei.imei))
    if (settings.track === "auto") fitBounds(activePop !== "filters");
    else {
      // temp force update
      mapRef.setZoom(mapRef.getZoom());
      // mapRef.panBy(0, 0);
      // forceUpdate();
    }
  }, [gpsMarkers]);

  useEffect(() => {
    console.log("gps clear points here");
    if (gps?.points) {
      if (gps?.live && gps?.points?.length == 1) {
        const panorama = mapRef.getStreetView();
        if (panorama.getVisible()) {
          console.log("panorama visible");
          setTimeout(async () => {
            const sv = new google.maps.StreetViewService();
            const samples = [...gpsReportTrack?.current?.points].reverse();
            const panoLocation = await findPanorama(sv, samples, 0);
            if (panoLocation.location) {
              const nextLocation = samples?.[panoLocation.index]?.dataset;
              panorama.setPosition({
                lat: nextLocation?.locationGps?.lat,
                lng: nextLocation?.locationGps?.long,
              });
              panorama.setPov({
                heading: nextLocation?.headingGps,
                pitch: 0,
              });
            }
          });
        } else {
          console.log("panorama not visible");
        }
      }

      gpsReportTrack.current = gps;
    } else {
      gpsReportTrack.current = undefined;
    }
  }, [gps]);

  const getPanorama = (sv, searchLocation) => {
    return new Promise((resolve, reject) => {
      sv.getPanorama({ location: searchLocation, radius: 50 })
        .then(({ data }: google.maps.StreetViewResponse) => {
          const location = data.location!;
          resolve(location);
        })
        .catch((e) => {
          console.log("Street View data not found for this location.");
          resolve(undefined);
        });
    });
  };

  const findPanorama = async (sv, samples, startIndex) => {
    let startLocation;
    while (startIndex < samples.length) {
      startLocation = samples?.[startIndex]?.dataset?.locationGps;
      let location: any = await getPanorama(sv, {
        lat: startLocation.lat,
        lng: startLocation.long,
      });
      if (location) {
        return {
          index: startIndex,
          location,
        };
      }
      startIndex++;
    }
    return {
      index: startIndex,
      location: undefined,
    };
  };

  const loopPanorama = (panorama, samples, startIndex) => {
    if (startIndex === samples.length - 1) {
      console.log("end of file");
      panorama.setVisible(false);
      return;
    }
    const sv = new google.maps.StreetViewService();
    setTimeout(async () => {
      if (!panorama.getVisible()) return;
      const panoLocation = await findPanorama(sv, samples, startIndex);
      if (panoLocation.location) {
        // panorama.setPano(panoLocation.location.pano as string);
        // panorama.setVisible(true);

        const nextLocation = samples?.[panoLocation.index]?.dataset;
        console.log(
          "timestamp",
          new Date(samples?.[panoLocation.index]?.timestamp)
        );

        panorama.setPosition({
          lat: nextLocation?.locationGps?.lat,
          lng: nextLocation?.locationGps?.long,
        });
        panorama.setPov({
          heading: nextLocation?.headingGps,
          pitch: 0,
        });
      } else {
        panorama.setVisible(false);
        return;
      }
      startIndex = panoLocation.index + 1;
      loopPanorama(panorama, samples, startIndex);
    }, 3000);
  };

  const onLoad = React.useCallback(function callback(ref) {
    const buttons = [
      ["Rotate Left", "rotate", 15, google.maps.ControlPosition.LEFT_CENTER],
      ["Rotate Right", "rotate", -20, google.maps.ControlPosition.RIGHT_CENTER],
      ["Tilt Down", "tilt", 15, google.maps.ControlPosition.TOP_CENTER],
      ["Tilt Up", "tilt", -20, google.maps.ControlPosition.BOTTOM_CENTER],
      ["Animate", "animate", 0, google.maps.ControlPosition.BOTTOM_CENTER],
    ];
    buttons.forEach(([text, mode, amount, position]) => {
      const controlDiv = document.createElement("div");
      const controlUI = document.createElement("button");

      controlUI.classList.add("ui-button");
      controlUI.innerText = `${text}`;
      controlUI.addEventListener("click", async () => {
        // adjustMap(mode, amount);
        switch (mode) {
          case "tilt":
            ref.setTilt(ref.getTilt() + amount);
            break;
          case "animate":
            // const panorama = new google.maps.StreetViewPanorama(
            //   document.getElementById("pano") as HTMLElement,
            //   {
            //     position: defaultLocation,
            //     pov: {
            //       heading: 34,
            //       pitch: 10,
            //     },
            //   }
            // );

            if (gpsReportTrack?.current?.points?.length > 0) {
              let samples;

              if (!gpsReportTrack?.current?.live) {
                samples = [...gpsReportTrack?.current?.points].reverse();
              } else {
                samples = [gpsReportTrack?.current?.points?.[0]];
              }
              console.log("samples", samples);
              const panorama = ref.getStreetView();
              let startIndex = 0;
              let startLocation;
              const sv = new google.maps.StreetViewService();
              // while(startIndex < samples.length -1){
              //   startLocation = samples?.[startIndex]?.dataset?.locationGps;
              //   let location: any = await getPanorama(sv, {
              //     lat: startLocation.lat,
              //     lng: startLocation.long,
              //   })
              //   if(location){
              //     console.log('finally found location', location);
              //     panorama.setPano(location.pano as string);
              //     panorama.setVisible(true);
              //     break;
              //   }
              //   startIndex ++;
              // }
              startLocation = await findPanorama(sv, samples, startIndex);
              if (startLocation.location) {
                panorama.setPano(startLocation.location.pano as string);
                panorama.setVisible(true);
              } else {
                pushNotification(
                  "Street view not found for this location",
                  "error",
                  "TOP_CENTER",
                  1000
                );
                return;
              }
              startIndex = startLocation.index;
              // const startLocation = samples?.[0]?.dataset?.locationGps;
              console.log("start location", startLocation);
              console.log("start index", startIndex);

              console.log("live", gpsReportTrack?.current?.live);

              if (!gpsReportTrack?.current?.live) {
                loopPanorama(panorama, samples, startIndex + 1);
              }
              // panorama.setPosition({
              //   lat: startLocation.lat,
              //   lng: startLocation.long,
              // });
              // panorama.setPosition({lat: 38.998985295881866, lng: -77.25626975297928});

              // const sv = new google.maps.StreetViewService();
              // sv.getPanorama({
              //   location: { lat: 38.998985295881866, lng: -77.25626975297928 },
              //   radius: 50,
              // })
              //   .then(({ data }: google.maps.StreetViewResponse) => {
              //     console.log("data here", data);
              //     const location = data.location!;
              //     panorama.setPano(location.pano as string);
              //   })
              //   .catch((e) =>
              //     console.error("Street View data not found for this location.")
              //   );

              // panorama.setVisible(true);

              // let index = startIndex + 1;
              // const interval = setInterval(() => {
              //   const isVisible = panorama.getVisible();
              //   if (index === samples.length - 1 || !isVisible) {
              //     clearInterval(interval);
              //     panorama.setVisible(false);
              //     return;
              //   }
              // const nextLocation = samples?.[index]?.dataset;
              // console.log("timestamp", new Date(samples?.[index]?.timestamp));
              //   panorama.setPosition({
              //     lat: nextLocation?.locationGps?.lat,
              //     lng: nextLocation?.locationGps?.long,
              //   });
              //   panorama.setPov({
              //     heading: nextLocation?.headingGps,
              //     pitch: 0,
              //   });
              //   index++;
              // }, 3000);
            }
            // ref.setStreetView(panorama);

            // panorama.setPosition(astorPlace);
            // panorama.setPov(
            //   /** @type {google.maps.StreetViewPov} */ {
            //     heading: 265,
            //     pitch: 0,
            //   }
            // );
            break;
          case "rotate":
            ref.setHeading(ref.getHeading() + amount);
            break;
          default:
            break;
        }
      });
      // controlDiv.appendChild(controlUI);
      // ref.controls[position].push(controlDiv);
    });
    new MeasureTool(ref, {
      showSegmentLength: true,
      unit: MeasureTool.UnitTypeId.IMPERIAL, // or just use 'imperial'
    });
    setMapRef(ref);
  }, []);

  return (
    <React.Fragment>
      {isLoaded && (
        <GoogleMap
          center={currentLocation}
          zoom={14}
          options={{
            mapId: "bc10cdbc8ba6566d",
          }}
          onZoomChanged={() => {
            onBoundsChanged();
          }}
          onCenterChanged={() => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
              onBoundsChanged();
            }, 500);
          }}
          onClick={onClick}
          onLoad={onLoad}
          mapContainerStyle={{ height: "100%", width: "100%" }}
        >
          {markers.map((marker: any, idx: number) => (
            <Marker
              // key={`${new Date().toString()}`}
              key={idx}
              icon={
                marker.markerIcon
                  ? marker.markerIcon
                  : {
                      url: `/images/map-plain-icon-${marker.color}.svg`,
                      scaledSize: new google.maps.Size(30, 44),
                    }
              }
              position={{ lat: marker.lat, lng: marker.lng }}
              onClick={() => {
                // props.onToggleOpen(marker)

                console.log("marker toggle open 1", marker);

                if (selectDirectionPin) {
                  handleDirections(marker);
                } else {
                  onToggleOpen({
                    type: "marker",
                    ...marker,
                    mode: marker.filter ? marker.filter : "edit",
                  });
                }
              }}
            >
              {(marker.objectType === "media" ||
                marker.objectType === "medium") &&
                marker?.urls?.original?.url && (
                  <InfoWindow position={{ lat: marker.lat, lng: marker.lng }}>
                    <div className="image-window">
                      {marker.data?.mimeType?.indexOf("image") !== -1 ? (
                        <Image
                          className="map-window-image"
                          src={marker?.urls?.original?.url}
                          width={100}
                        />
                      ) : (
                        <img
                          src="/images/media-icon.png"
                          width="100"
                          style={{ cursor: "pointer" }}
                          alt=""
                          onClick={() => {
                            if (
                              marker.data?.mimeType?.indexOf("video") !== -1
                            ) {
                              setVideoModalOpen(marker?.urls?.original?.url);
                            } else {
                              window.open(
                                marker.data.urls.original.url,
                                "_blank"
                              );
                            }
                          }}
                        />
                      )}
                    </div>
                  </InfoWindow>
                )}
            </Marker>
          ))}

          <Marker
            position={currentLocation}
            icon={{
              url: `/images/map-plain-icon-blue.svg`,
              scaledSize: new google.maps.Size(30, 44),
            }}
            onClick={
              () => {
                if (selectDirectionPin) {
                  handleDirections({
                    lat: currentLocation.lat,
                    lng: currentLocation.lng,
                  });
                } else {
                  onToggleOpen({
                    title: "current location",
                    lat: currentLocation.lat,
                    lng: currentLocation.lng,
                    type: "marker",
                  });
                }
              }
              // props.onToggleOpen({type: 'marker', ...props.currentLocation, mode: 'edit'})
            }
          ></Marker>

          <DrawingManager
            // defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
            drawingMode={drawingMode}
            options={{
              drawingControl: true,
              drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                  google.maps.drawing.OverlayType.MARKER,
                  google.maps.drawing.OverlayType.POLYGON,
                  google.maps.drawing.OverlayType.CIRCLE,
                ],
              },
              polygonOptions: {
                editable: true,
              },
              markerOptions: {
                icon: `/images/map-plain-icon-blue.svg`,
              },
            }}
            onCircleComplete={(circle: any) => {
              onToggleOpen({
                type: "circle",
                mode: "new",
                geometry: circle,
                title: "Circle",
                lat: circle.center.lat(),
                lng: circle.center.lng(),
                radius: circle.radius,
              });
              setDrawingMode(undefined);
            }}
            onPolygonComplete={(polygon: any) => {
              let paths = getPaths(polygon);
              onToggleOpen({
                type: "polygon",
                mode: "new",
                geometry: polygon,
                title: "Polygon",
                lat: paths[0].lat,
                lng: paths[0].lng,
              });
              setDrawingMode(undefined);
            }}
            onMarkerComplete={(marker: any) => {
              onToggleOpen({
                type: "marker",
                mode: "new",
                geometry: marker,
                title: "Marker",
                lat: marker.position.lat(),
                lng: marker.position.lng(),
              });
              setDrawingMode(undefined);
            }}
          />

          {polygons.map((polygon: any, idx: number) => (
            <Polygon
              path={polygon.paths}
              key={idx}
              editable={false}
              options={{
                strokeColor: polygon.color?.hex ?? "#000",
                fillColor: polygon.color?.hex ?? "#000",
              }}
              onClick={(click) => {
                onToggleOpen({ type: "polygon", ...polygon, mode: "edit" });
              }}
            />
          ))}

          {circles.map((circle: any, idx: number) => (
            <Circle
              key={idx}
              center={{
                lat: circle.lat,
                lng: circle.lng,
              }}
              radius={circle.radius}
              options={{
                strokeColor: circle.color?.hex ?? "#000",
                fillColor: circle.color?.hex ?? "#000",
              }}
              onClick={(click) => {
                onToggleOpen({ type: "circle", ...circle, mode: "edit" });
              }}
            />
          ))}

          {directions && active && (
            <DirectionsRenderer
              directions={directions}
              options={{
                markerOptions: { opacity: 1 },
                panel: document.getElementById("direction-panel"),
                // icon: { scale: 10 },
              }}
            />
          )}

          {Object.keys(gpsMarkers).map((key, idx) => (
            <React.Fragment>
              {!polyline &&
                gpsMarkers[key].markers
                  .slice(
                    0,
                    settings.breadcrumbs?.[0] === "Show breadcrumbs"
                      ? gpsMarkers[key].length
                      : 1 ?? 1
                  )
                  .filter((marker) => {
                    return insideBox.indexOf(marker.gpsTimestamp) !== -1;
                  })
                  .map((marker: any, idy: number) => (
                    <Marker
                      // key={`${new Date().toString()}`}
                      key={idy}
                      icon={marker.icon}
                      position={{ lat: marker.lat, lng: marker.lng }}
                      onRightClick={() => {
                        toggleLock(marker.imei);
                      }}
                      onClick={() => {
                        // props.onToggleOpen(marker)

                        console.log("marker toggle open", marker);

                        if (selectDirectionPin) {
                          handleDirections(marker);
                        } else {
                          onToggleOpen({
                            type: "marker",
                            ...marker,
                            mode: "edit",
                          });
                        }
                      }}
                    ></Marker>
                  ))}

              {polyline && (
                <Polyline
                  path={gpsMarkers[key].markers}
                  options={{
                    strokeColor: gpsMarkers[key].color,
                  }}
                />
              )}
            </React.Fragment>
          ))}

          {isOpen && activeMarker && (
            <PinPop
              setActivePop={onToggleOpen}
              currentLocation={currentLocation}
              marker={activeMarker}
              // showDirection={(directions)=>{
              // props.showDirection(directions);
              // props.showPanel(true)
              // }}
              showDirection={(pin) => {
                setSelectDirectionPin(pin);
              }}
              setActive={setActive}
            />
          )}

          {selectDirectionPin && (
            // <div className="destination-pin">
            //     Select destination pin to find the direction
            //     <CloseOutlined className="close-icon" onClick={()=>{props.setSelectDirectionPin(null)}}/>
            // </div>

            <DirectionPop
              currentLocation={currentLocation}
              showDirections={(direction) => {
                handleDirections(direction);
              }}
              setActivePop={() => {
                setSelectDirectionPin(null);
              }}
            />
          )}

          {mapRef && (
            <Row className="map-rotation-icons">
              <Col span={8} className={""}>
                <Button
                  className="ui-button"
                  onClick={() => {
                    mapRef.setHeading(mapRef.getHeading() + 15);
                  }}
                >
                  <img className="action-icon" src="/images/left.png" />
                </Button>
              </Col>
              <Col className={"flex-column"} span={8}>
                <Button
                  className="ui-button"
                  onClick={() => {
                    mapRef.setTilt(mapRef.getTilt() - 15);
                  }}
                >
                  <img className="action-icon" src="/images/up.png" />
                </Button>
                <Button
                  className="ui-button blue"
                  onClick={async () => {
                    if (gpsReportTrack?.current?.points?.length > 0) {
                      let samples;
                      if (!gpsReportTrack?.current?.live) {
                        samples = [
                          ...gpsReportTrack?.current?.points,
                        ].reverse();
                      } else {
                        samples = [gpsReportTrack?.current?.points?.[0]];
                      }
                      const panorama = mapRef.getStreetView();
                      let startIndex = 0;
                      let startLocation;
                      const sv = new google.maps.StreetViewService();
                      startLocation = await findPanorama(
                        sv,
                        samples,
                        startIndex
                      );
                      if (startLocation.location) {
                        panorama.setPano(startLocation.location.pano as string);
                        panorama.setVisible(true);
                      } else {
                        pushNotification(
                          "Street view not found for this location",
                          "error",
                          "TOP_CENTER",
                          1000
                        );
                        return;
                      }
                      startIndex = startLocation.index;
                      if (!gpsReportTrack?.current?.live) {
                        loopPanorama(panorama, samples, startIndex + 1);
                      }
                    }
                  }}
                >
                  <img className="action-icon" src="/images/animate.png" />
                </Button>
                <Button
                  className="ui-button"
                  onClick={() => {
                    mapRef.setTilt(mapRef.getTilt() + 15);
                  }}
                >
                  <img className="action-icon" src="/images/down.png" />
                </Button>
              </Col>
              <Col className={""} span={8}>
                <Button
                  className="ui-button"
                  onClick={() => {
                    mapRef.setHeading(mapRef.getHeading() - 15);
                  }}
                >
                  <img className="action-icon" src="/images/right.png" />
                </Button>
              </Col>
            </Row>
          )}

          {videoModalOpen && (
            <VideoPlayerModal
              url={videoModalOpen}
              onClose={() => setVideoModalOpen(undefined)}
            />
          )}
        </GoogleMap>
      )}
    </React.Fragment>
  );
};

export default Map;
